/* pd-r17 — Apple design pass, round 3 (17 Oct 2026).
   1. Bag: swipe an item left to remove it, with a 5-second Undo.
   4. Category chips: soft fade where the row continues; the chip you pick slides to the middle. */
(function () {
  'use strict';
  var reduce = matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- 1. Swipe to remove, with Undo ---------- */
  var SLOP = 8, DECEL = 0.998;
  function project(v) { return (v / 1000) * DECEL / (1 - DECEL); }
  function rubber(over, dim) { var c = 0.55; return (over * dim * c) / (dim + c * Math.abs(over)); }
  var g = null;

  function sidebar() { return document.getElementById('site-cart-sidebar'); }

  function refreshBag() {                                            // same refresh the theme's own cart form uses
    return fetch('?section_id=helper-cart').then(function (r) { return r.text(); }).then(function (text) {
      var doc = new DOMParser().parseFromString(text, 'text/html');
      var form = document.getElementById('AjaxCartForm');
      var newForm = doc.getElementById('AjaxCartForm'), newSub = doc.getElementById('AjaxCartSubtotal');
      if (!form || !newForm) { location.reload(); return; }
      form.innerHTML = newForm.innerHTML;
      if (form.ajaxifyCartItems) form.ajaxifyCartItems();
      var count = form.querySelector('[data-cart-count]'), total = form.querySelector('[data-cart-total]');
      document.querySelectorAll('[data-header-cart-count]').forEach(function (el) { if (count) el.textContent = count.textContent; });
      document.querySelectorAll('[data-header-cart-total]').forEach(function (el) { if (total) el.textContent = total.textContent; });
      var sub = document.getElementById('AjaxCartSubtotal'); if (sub && newSub) sub.innerHTML = newSub.innerHTML;
      form.dispatchEvent(new Event('cart-updated'));
    });
  }

  var undoBar = null, undoTimer = null;
  function showUndo(line) {
    var sb = sidebar(); if (!sb) return;
    if (!undoBar) {
      undoBar = document.createElement('div');
      undoBar.className = 'pd-r17-undo';
      undoBar.setAttribute('role', 'status');
      undoBar.innerHTML = '<span></span><button type="button">Undo</button>';
      undoBar.querySelector('button').addEventListener('click', function () {
        var l = undoBar._line; if (!l) return;
        undoBar._line = null; hideUndo();
        fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: l.variant_id, quantity: l.quantity, properties: l.properties || {} }] })
        }).then(refreshBag);
      });
    }
    if (undoBar.parentNode !== sb) sb.appendChild(undoBar);
    undoBar._line = line;
    undoBar.querySelector('span').textContent = 'Removed ' + (line.product_title || 'item');
    requestAnimationFrame(function () { undoBar.classList.add('is-on'); });
    clearTimeout(undoTimer);
    undoTimer = setTimeout(hideUndo, 5000);
  }
  function hideUndo() { if (undoBar) undoBar.classList.remove('is-on'); clearTimeout(undoTimer); }

  function removeItem(item) {
    var key = (item.dataset.id || '');
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var line = null;
      cart.items.forEach(function (it) { if (it.key === key) line = it; });
      var h = item.offsetHeight;
      item.style.height = h + 'px';
      item.classList.add('pd-r17-gone');
      requestAnimationFrame(function () { item.style.height = '0px'; });
      var rm = item.querySelector('.remove');
      setTimeout(function () {
        if (rm) rm.click(); else refreshBag();                          // the theme's own Remove link does the work
        if (line) showUndo(line);
      }, reduce.matches ? 0 : 240);
    });
  }

  function onDown(e) {
    if (e.pointerType === 'mouse' || g) return;
    var item = e.target.closest('#site-cart-sidebar .cart-item');
    if (!item || !item.querySelector('.remove') || e.target.closest('input, textarea, select, button')) return;
    g = { item: item, id: e.pointerId, x0: e.clientX, y0: e.clientY, live: false, dx: 0, w: item.offsetWidth, hist: [{ t: e.timeStamp, x: e.clientX }] };
  }
  function onMove(e) {
    if (!g || e.pointerId !== g.id) return;
    var dx = e.clientX - g.x0, dy = e.clientY - g.y0;
    if (!g.live) {
      if (Math.abs(dx) < SLOP && Math.abs(dy) < SLOP) return;
      if (Math.abs(dy) > Math.abs(dx) || dx > 0) { g = null; return; } // scroll, or a swipe right that closes the bag
      g.live = true; g.base = dx;
      try { g.item.setPointerCapture(g.id); } catch (_) {}
      g.item.classList.add('pd-r17-drag');
    }
    e.stopPropagation();                                              // this swipe is ours, not the bag drawer's
    var d = dx - g.base;
    if (d > 0) d = rubber(d, g.w);
    g.dx = d;
    g.hist.push({ t: e.timeStamp, x: e.clientX }); if (g.hist.length > 6) g.hist.shift();
    g.item.style.setProperty('--pd-r17-dx', d + 'px');
  }
  function onUp(e) {
    if (!g || e.pointerId !== g.id) return;
    var s = g; g = null;
    if (!s.live) return;                                              // let the release reach the drawer script so it resets too
    var a = s.hist[0], b = s.hist[s.hist.length - 1];
    var v = (b.x - a.x) / Math.max(1, b.t - a.t) * 1000;              // px/s, negative = towards remove
    var remove = e.type !== 'pointercancel' && (s.dx + project(v) < -s.w * 0.5);
    s.item.classList.remove('pd-r17-drag');
    s.item.classList.add('pd-r17-settle');
    s.item.style.setProperty('--pd-r17-dx', remove ? (-s.w) + 'px' : '0px');
    setTimeout(function () {
      s.item.classList.remove('pd-r17-settle');
      if (remove) removeItem(s.item); else s.item.style.removeProperty('--pd-r17-dx');
    }, reduce.matches ? 0 : 280);
  }
  function bind() {
    var sb = sidebar(); if (!sb || sb.dataset.pdR17) return;
    sb.dataset.pdR17 = '1';
    sb.addEventListener('pointerdown', onDown, { passive: true });
    sb.addEventListener('pointermove', onMove, { passive: true });
    sb.addEventListener('pointerup', onUp, { passive: true });
    sb.addEventListener('pointercancel', onUp, { passive: true });
  }

  /* ---------- 4. Category chips ---------- */
  function edges(bar) {
    var max = bar.scrollWidth - bar.clientWidth;
    bar.classList.toggle('pd-r17-more-l', bar.scrollLeft > 4);
    bar.classList.toggle('pd-r17-more-r', bar.scrollLeft < max - 4);
  }
  function chips() {
    document.querySelectorAll('.pdcc__bar').forEach(function (bar) {
      if (bar.dataset.pdR17) return;
      bar.dataset.pdR17 = '1';
      edges(bar);
      bar.addEventListener('scroll', function () { edges(bar); }, { passive: true });
      bar.addEventListener('click', function (e) {
        var chip = e.target.closest('.pdcc__chip'); if (!chip) return;
        var left = chip.offsetLeft - (bar.clientWidth - chip.offsetWidth) / 2;
        bar.scrollTo({ left: Math.max(0, left), behavior: reduce.matches ? 'auto' : 'smooth' });
      });
    });
  }
  window.addEventListener('resize', function () { document.querySelectorAll('.pdcc__bar').forEach(edges); });

  function init() { bind(); chips(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  setTimeout(init, 1500);                                             // the chip row is built by another script after load
})();
